import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { AuthContext } from "../Auth/AuthDataProvider.jsx";
import apiUtil from '../../api/apiUtil.jsx';
import api from "../../api/api.jsx";

import { 
  Collapse,
  List,
  ListItem,
  Button,
  Menu,
  MenuItem,
  Box,
  Divider
} from '@material-ui/core';

import CustomDialog from '../Dialog/CustomDialog.jsx';

import { ReactComponent as ArrowDownIcon } from '../../assets/img/left_menu/arrow-down.svg';
import { ReactComponent as ArrowRightIcon } from '../../assets/img/left_menu/arrow-right.svg';
import defaultImg from '../../assets/img/default_image.jpg';
import {RoleAccessService} from '../../data/role-access'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGear } from '@fortawesome/free-solid-svg-icons'

  
const CustomMenuItem = (props) => {
  let {text, icon, url, active, items, onDrawerToggle} = props;
  let [open, setOpen] = React.useState(active);

  return <React.Fragment>
    <ListItem
      // onClick = {() => onDrawerToggle? onDrawerToggle(): ""}
      className={'custom-item ' + ((typeof active === "function") ? active() : (active ? "active" : ""))}
    >
      <Link to={(items && items.length > 0) ? "" : url}
        onClick={(e) => {
          // e.stopPropagation();

          if(items && items.length > 0){
            e.preventDefault();
            setOpen(!open);
            
            if(onDrawerToggle){
              onDrawerToggle()
            }
          }
        }}
        className="d-flex flex-column text-center"
      >
        {icon ? <div className="icon-style">{icon}</div> : <span className={'no-icon'}></span>}
        <div className="nav-text">{text}</div>
        {(items && items.length > 0) && (open ? <ArrowDownIcon className={'custom-expand-down'} /> : <ArrowRightIcon className={'custom-expand-right'} />)}
      </Link>
    </ListItem>
    {(items && items.length > 0) && <Collapse in={open} timeout="auto" unmountOnExit>
      <List className={'sub-nav'} component="div" disablePadding>
        {items.map((item, i) => {
          return <React.Fragment key={i}>
            {item}
          </React.Fragment>;
        })}
      </List>
    </Collapse>}
  </React.Fragment>
}

class CustomerProfileDropdown extends Component {
  static contextType = AuthContext;

  constructor(props){
    super(props);

    this.state = {
      profileMenu: null,
      openDialog: false,
      isLoading: false,
    };
  }


  componentWillReceiveProps(nextProps) {
    if (nextProps.profileMenu !== this.state.profileMenu) {
        this.setState({
            profileMenu: nextProps.profileMenu
        });
    }
  }

  /* API */
  callUpdateAdminProfileApi = (callback = null) => {
    const { user, accessToken, setOnBoardingCustomer, setOnBoardingVehicle, setOnBoardingDriver, setOnBoardingJob } = this.context;
    
    this.setState({
      isLoading: true
    }, () => {
      let firstName = apiUtil.getFirstName(user);
      let lastName = apiUtil.getLastName(user);
  
      let params = {
        "first_name": firstName,
			  "last_name": lastName,
			  "is_onboarding": true
      };

      api.updateAdminProfile('profile/admins', params, accessToken).then((result) => {
        apiUtil.parseResult(result, (data) => {
          this.setState({
            isLoading: false,
          }, () => {
            setOnBoardingCustomer(null);
            setOnBoardingVehicle(null);
            setOnBoardingDriver(null);
            setOnBoardingJob(null);

            if(callback){
              callback(data.result);
            }
          });
        }, (error, type) => {
          this.setState({
            isLoading: false,
          }, () => {
            if(callback){
              callback(null);
            }
          });
        });
      });
    });
  }
  /* END API */


  /* DIALOG */
  customDialog = () => {
    return <CustomDialog 
      open={this.state.openDialog}
      title={'Onboarding'}
      btnCloseText={'No'}
      onClose={() => {
        this.setState({
          openDialog: false,
        });
      }}
      onOk={() => {
        this.callUpdateAdminProfileApi((data) => {
          this.setState({
            openDialog: false,
          }, () => {
            apiUtil.toastOnBoarding('Done', 'check_circle');
            this.props.history.push('/');
          });
        });
      }}
    >
      <Box>Do you want to re-run onboarding process?</Box>
    </CustomDialog>
  }
  /* END DIALOG */

  render() {
    const { isCustomerRequired, currentRole } = this.context;
    let grantedMenu = new RoleAccessService();
    return <Box textAlign="right" height="100%" ml={3} className="customer-header-profile">
      <CustomMenuItem
          icon={<FontAwesomeIcon icon={faGear} />}
          url={'/settings'}
          active={(this.props.location.pathname === "/settings"? true : false)}
        />

      {this.customDialog()}
    </Box>
  }
}

export default withRouter(CustomerProfileDropdown);
